import CacheOperations from '@/components/common/ed-board/ed-board-tools/ed-board-persistence/board-cache-operations';
import { BaseWboPersistenceProvider } from '@webcat/wbo-client';

/**
 * WboPersistenceProvider that uses browser storage (IndexedDB if available, or localStorage, if the former is not
 * available to persist the data).
 */
export default class WboIndexedDBPersistenceProvider extends BaseWboPersistenceProvider {
    /**
     * IndexedDB or localStorage handle to do the actual persistence.
     */
    private readonly cacheOperations: CacheOperations = null;

    constructor(boardName: string, username: string) {
        super(boardName, username)
        this.cacheOperations = CacheOperations.getInstance();
    }

    async saveDataToStorage(fileName : string, data : any): Promise<void>{
        await this.cacheOperations.setItem(fileName, data)
    }
    async readDataFromStorage(fileName : string): Promise<any>{
        return await this.cacheOperations.getItem(fileName);
    }
    async deleteFromStorage(fileName : string): Promise<void>{
        await this.cacheOperations.deleteItem(fileName);
    }


}
